import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faTimes, faShoppingCart,faSearch,faFileExcel ,faFilePdf ,faSpinner, faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons";
import config from "../../config";
import { DatePicker } from "antd";
import moment from "moment";
import html2canvas from "html2canvas";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Styles/stock.css";
import PurchaseForm from "../PurchaseComponent/purchaseform";
import { useNavigate } from "react-router-dom";

const StockDetailsPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [medicineData, setMedicineData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fromExpiryDate, setFromExpiryDate] = useState(null);
  const [toExpiryDate, setToExpiryDate] = useState(null);
  const [loader, setLoader] = useState(false);
  const [editedRows, setEditedRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [successAlert, setSuccessAlert] = useState(null);
  const navigate =useNavigate();
  const [editedData, setEditedData] = useState({
    originalData: {},
    lastEditTimestamp: null,
  });
  const [editMode, setEditMode] = useState(null);
  const itemsPerPage = 25;

  const filteredData = medicineData
    .filter(
      (item) =>
        item.medicinename &&
        item.medicinename.toLowerCase().includes(searchQuery.toLowerCase()) &&
        (!fromExpiryDate ||
          moment(item.expirydate).isSameOrAfter(fromExpiryDate)) &&
        (!toExpiryDate || moment(item.expirydate).isSameOrBefore(toExpiryDate))
    )
    .sort((a, b) => {
      return moment(a.expirydate) - moment(b.expirydate);
    });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const dataOnCurrentPage = filteredData.slice(startIndex, endIndex);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleViewClick = () => {
    openModal ();
  }

  const fetchStockData = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/pharmacy/stock`, {
        params: { medicinename: searchQuery, fromExpiryDate, toExpiryDate },
      });

      setMedicineData(response.data);
      console.log("Updated Medicine Data:", response.data);
    } catch (error) {
      console.error("Error fetching stock data:", error);
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request error:", error.message);
      }
    }
  };

  useEffect(() => {
    fetchStockData();
  }, [searchQuery, fromExpiryDate, toExpiryDate]);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}/pharmacy/stock`);
        setMedicineData(response.data);
      } catch (error) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };
    fetchStockData();
  }, []);

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleFromDateChange = (date, dateString) => {
    setFromExpiryDate(moment(dateString).startOf('day').toISOString());
    setCurrentPage(1);
  };

  const handleToDateChange = (date, dateString) => {
    setToExpiryDate(moment(dateString).endOf('day').toISOString());
    setCurrentPage(1);
  };


  const handleSaveEdit = async (id, updatedData) => {
    try {

      const response = await axios.put(
        `${config.apiUrl}/pharmacy/stock/update/${id}`,
        updatedData
      );

      setEditedRows((prevEditedRows) => [
        ...prevEditedRows,
        { id, timestamp: new Date() },
      ]);

      setMedicineData((prevMedicineData) => {
        const updatedMedicineData = prevMedicineData.map((item) =>
          item.id === id ? { ...item, ...updatedData } : item
        );
        return updatedMedicineData;
      });

      setEditMode(null);
      setSuccessAlert(
        <div className="fixed top-15 left-1/2 flex items-center justify-center bg-green-600 text-white p-4 rounded-md">
          Stock item updated successfully
        </div>
      );

      setTimeout(() => {
        setSuccessAlert(null);
      }, 2000);
    } catch (error) {
      console.error("Error updating stock item:", error);
      alert("Error updating stock item. Please try again later.");
    }
  };

  const handleDelete = async (id) => {
    console.log("Deleting item with ID:", id);

    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        const response = await axios.delete(
          `${config.apiUrl}/pharmacy/stock/delete/${id}`
        );
        console.log("Delete response:", response.data);

        if (response.status === 200) {
          setMedicineData((prevMedicineData) =>
            prevMedicineData.filter((item) => item.id !== id)
          );

          setSuccessAlert(
            <div className="fixed top-15 left-1/2 flex items-center justify-center bg-green-500 text-white p-4 rounded-md">
              Stock item deleted successfully
            </div>
          );
    
          setTimeout(() => {
            setSuccessAlert(null);
          }, 2000);
        } else {
          alert("Failed to delete stock item. Please try again later.");
        }
      } catch (error) {
        console.error("Error deleting stock item:", error);
        alert("Error deleting stock item. Please try again later.");
      }
    }
  };

  const handleEdit = (id) => {
    const index = medicineData.findIndex((item) => item.id === id);

    if (index !== -1) {
      setEditMode(id);

      setEditedData((prevData) => {
        const updatedMedicineData = [...medicineData];
        const editedItem = { ...updatedMedicineData[index] };

        return {
          ...editedItem,
          originalData: { ...editedItem },
          lastEditTimestamp: new Date(),
        };
      });
    }
  };

  const isRowEdited = (id) => editedRows.some((row) => row.id === id);

  const handleCancelEdit = () => {
    setEditMode(null);
    setEditedData({});
  };

  const handleChangeEditData = (name, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
      lastEditTimestamp: new Date(),
    }));
  };

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("StockData");

    worksheet.columns = [
      { header: "Purchase Date", key: "purchasedate", width: 15 },
      { header: "Medicine Name", key: "medicinename", width: 15 },
      { header: "Dosage", key: "dosage", width: 15 },
      { header: "Brand Names", key: "brandname", width: 15 },
      { header: "Purchase Price", key: "purchaseprice", width: 15 },

      { header: "MRP", key: "mrp", width: 15 },
      { header: "Total Qty", key: "totalqty", width: 15 },
      { header: "Expiry Date", key: "expirydate", width: 15 },
    ];

    const headerRow = worksheet.getRow(1);

    worksheet.columns.forEach((column) => {
      const cell = headerRow.getCell(column.key);
      if (
        [
          "purchasedate",
          "medicinename",
          "dosage",
          "brandname",
          "purchaseprice",

          "mrp",
          "totalqty",
          "expirydate",
        ].includes(column.key)
      ) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF001F3F" },
        };
        cell.alignment = { horizontal: "center" };
      }
      cell.font = {
        color: { argb: "FFFFFF" },
        bold: true,
      };
    });

    filteredData.forEach((item) => {
      const formattedDate = item.purchasedate
        ? moment(item.purchasedate).format("YYYY-MM-DD")
        : "0";

      const dataRow = worksheet.addRow({
        purchasedate: formattedDate,
        medicinename: item.medicinename || "0",
        dosage: item.dosage || "0",
        brandname: item.brandname || "0",
        purchaseprice: item.purchaseprice || "0",

        mrp: item.mrp || "0",
        totalqty: item.totalqty || "0",
        expirydate: item.expirydate
          ? moment(item.expirydate).format("YYYY-MM-DD")
          : "0",
      });

      dataRow.alignment = { horizontal: "center" };

      dataRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "stock.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  const downloadPDF = () => {
    const html2canvasOptions = {
      scale: 2,
      logging: false,
      allowTaint: true,
    };

    const capture = document.querySelector(".stock-table");
    setLoader(true);

    html2canvas(capture, html2canvasOptions).then((canvas) => {
      const jsPDFOptions = {
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      };

      const pdf = new jsPDF(jsPDFOptions);
      const imageWidth = 210;
      const imageHeight = (canvas.height * imageWidth) / canvas.width;

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(16);
      pdf.setTextColor(43, 128, 176);

      const headingText =
        fromExpiryDate && toExpiryDate
          ? `Stock Details from ${moment(fromExpiryDate).format(
            "YYYY-MM-DD"
          )} to ${moment(toExpiryDate).format("YYYY-MM-DD")}`
          : "Stock Details as on Today";

      pdf.text(headingText, 10, 10, null, null, "left");

      const headingHeight = 20;
      const tableStartY = 0 + headingHeight;
      const firstPageData = filteredData.slice(0, itemsPerPage);
      const firstPageBodyData = firstPageData.map((currentData) => [
        currentData.purchasedate
          ? moment(currentData.purchasedate).format("YYYY-MM-DD")
          : "0",
        currentData.medicinename || "0",
        currentData.dosage || "0",
        currentData.brandname || "0",
        currentData.purchaseprice || "0",

        currentData.mrp || "0",
        currentData.totalqty || "0",
        currentData.expirydate
          ? moment(currentData.expirydate).format("YYYY-MM-DD")
          : "0",
      ]);

      pdf.autoTable({
        head: [
          [
            "Purchase Date",
            "Medicine Name",
            "Dosage",
            "Brand Name",
            "Purchase Price",
            "Purchase Amount",
            "MRP",
            "Total Qty",
            "Expiry Date",
          ],
        ],
        body: firstPageBodyData,
        startY: tableStartY,
        theme: "grid",
        styles: {
          fontSize: 9,
          halign: "center",
        },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          lineWidth: 0.3,
        },
        columnStyles: {
          0: { cellWidth: 20, cellHeight: 10 },
          1: { cellWidth: 30, cellHeight: 10 },
        },
        alternateRowStyles: {
          fillColor: [224, 224, 224],
          lineWidth: 0.3,
        },
      });

      let rowIndex = itemsPerPage;
      const numberOfRows = filteredData.length;

      while (rowIndex < numberOfRows) {
        pdf.addPage();
        pdf.text(`Page ${Math.ceil((rowIndex + 1) / itemsPerPage)}`, 10, 10);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(16);
        pdf.setTextColor(43, 128, 176);

        const currentPageData = filteredData.slice(
          rowIndex,
          rowIndex + itemsPerPage
        );
        const bodyData = currentPageData.map((currentData) => [
          currentData.purchasedate
            ? moment(currentData.purchasedate).format("YYYY-MM-DD")
            : "0",
          currentData.medicinename || "0",
          currentData.dosage || "0",
          currentData.brandname || "0",
          currentData.purchaseprice || "0",

          currentData.mrp || "0",
          currentData.totalqty || "0",
          currentData.expirydate
            ? moment(currentData.expirydate).format("YYYY-MM-DD")
            : "0",
        ]);

        pdf.autoTable({
          head: [
            [
              "Purchase Date",
              "Medicine Name",
              "Dosage",
              "Brand Name",
              "Purchase Price",
              "Purchase Amount",
              "MRP",
              "Total Qty",
              "Expiry Date",
            ],
          ],
          body: bodyData,
          startY: tableStartY,
          theme: "grid",
          styles: {
            fontSize: 9,
            halign: "center",
          },
          headerStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            lineWidth: 0.3,
          },
          columnStyles: {
            0: { cellWidth: 20, cellHeight: 10 },
            1: { cellWidth: 30, cellHeight: 10 },
          },
          alternateRowStyles: {
            fillColor: [224, 224, 224],
            lineWidth: 0.3,
          },
        });

        rowIndex += itemsPerPage;
      }

      setLoader(false);
      pdf.save("stock.pdf");
    });
  };

  const tdStyle = {
    textAlign: "center",
    whiteSpace: "nowrap",
  };
  const thStyle = {
    textAlign: "center",
  };

  return (
    <div>
      <div
         style={{
           marginTop: "2px",
           fontFamily: "serif",
         }}
      >
        {successAlert}
<div className='text-left'>
<div className="flex items-center justify-between w-full pb-4">
        <button
          className="flex items-center gap-2 p-2 bg-blue-800 text-white rounded hover:bg-blue-600"
          onClick={() => navigate('/pharmacy')}
        >
          <FontAwesomeIcon icon={faArrowCircleLeft} />
        </button>

        <h1 className="text-2xl font-bold text-green-400 flex-grow text-center">
        Stock Module 
        </h1>
      </div>
  <h2 className="text-2xl font-bold">
    <b>Stock Details</b>
  </h2>
  <h6 >View your stock list</h6>
</div>
</div>

      <div >
      <div className="flex items-center justify-between">
  <div className="flex items-center ml-[80px] ">
    <FontAwesomeIcon
      icon={faShoppingCart}
      className="cursor-pointer text-gray-400 text-2xl mr-7"
      onClick={handleViewClick}
    />
    {isModalOpen && (
      <div className="fixed inset-0 overflow-y-auto transition-all duration-300 backdrop-filter  backdrop-blur" style={{ zIndex: 9999 }}>
        <div className="flex items-center justify-center h-screen">
          <div className="bg-white p-4 w-1/2 md:w-1/2 lg:w-2/4 rounded shadow-lg transition-transform duration-300 transform scale-100 border-2 border-blue-500 max-h-full overflow-auto" style={{ scrollbarWidth: 'thin', scrollbarColor: 'rgba(0, 0, 0, 0.5) transparent' }}>
            <div className="flex justify-end items-center">
              <div className="flex items-center">
                <FontAwesomeIcon
                  icon={faTimes}
                  onClick={closeModal}
                  className="text-red-500 cursor-pointer"
                  size="lg"
                />
              </div>
            </div>
            <PurchaseForm isOpen={openModal} onClose={closeModal} />
          </div>
        </div>
      </div>
    )}
  </div>

  <div className="flex items-center space-x-4 -mt-[40px]">
    <button
      type="button"
      className="btn p-3 bg-blue-700 text-white rounded"
      onClick={exportToExcel}
    >
      <FontAwesomeIcon icon={faFileExcel} className="me-2" />
      Excel
    </button>
    <button
      onClick={downloadPDF}
      style={{ backgroundColor: 'blue', color: 'white' }}
      disabled={!(loader === false)}
      className="export"
    >
      {loader ? (
        <>
          <FontAwesomeIcon icon={faSpinner} className="me-2 animate-spin" />
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faFilePdf} className="me-2" />
          <span>PDF</span>
        </>
      )}
    </button>
  </div>
</div>

<div >
  <div className="col-10 col-md-8 mt-10 "  style={{ zIndex: 1 }}>
    <div className="search-bar flex items-center" >
      <FontAwesomeIcon icon={faSearch} />
      <input
        type="text"
        placeholder="Search..."
        value={searchQuery}
        style={{ height: "30px" }}
        onChange={(event) => handleSearchChange(event.target.value)}
      />
    </div>

   
   
  </div></div>
 
  <div className="col-12 col-md-12 float-right ml-auto -mt-[60px] ">
    <h6 className="text-18 font-serif text-center">
      <b>Expiry Date Filter</b>
    </h6>
 
    <div className="flex justify-end ]">
      <span className="font-bold ">
        From <DatePicker className="font-bold" onChange={handleFromDateChange} />
      </span>
      <span className="font-bold ">
        To <DatePicker className="font-bold" onChange={handleToDateChange} />
      </span>
    </div>
  </div>
        <div className="stock-table" style={{ marginLeft: "0px" }}>
          {dataOnCurrentPage.length === 0 ? (
            <p>No search results found</p>
          ) : (
            <div>
              <div style={{ overflowX: "auto" }}>
                <div className="scrollable-body">
                  <table className="table">
                    <thead className="sticky-top bg-light">
                      <tr>
                        <th style={thStyle}>Purchase Date</th>
                        <th style={thStyle}>Medicine Name</th>
                        <th style={thStyle}>Dosage</th>
                        <th style={thStyle}>Brand Name</th>
                        <th style={thStyle}>Purchase Price</th>
                        <th style={thStyle}>MRP</th>
                        <th style={thStyle}>Total Qty</th>
                        <th style={thStyle}>Expiry Date</th>
                        <th style={thStyle}></th>
                        <th style={thStyle}>Edit</th>
                        <th style={thStyle}>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataOnCurrentPage.map((item, index) => (
                        <tr key={item.id}>
                          <td style={tdStyle}>
                            {item.purchasedate
                              ? moment(item.purchasedate).format("YYYY-MM-DD")
                              : "0"}
                          </td>

                          <td style={{ ...tdStyle, textAlign: "left" }}>
                            {item.medicinename || "0"}
                          </td>
                          <td style={tdStyle}>{item.dosage || "0"}</td>

                          <td style={tdStyle}>
                            {
                              item.brandname || "0"
                            }
                          </td>
                          <td style={tdStyle}>
                            {editMode === item.id ? (
                              <input
                                type="text"
                                value={editedData.purchaseprice}
                                onChange={(e) =>
                                  handleChangeEditData(
                                    "purchaseprice",
                                    e.target.value
                                  )
                                }
                              />
                            ) : (
                              item.purchaseprice || "0"
                            )}
                          </td>

                          <td style={tdStyle}>
                            {editMode === item.id ? (
                              <input
                                type="text"
                                value={editedData.mrp}
                                onChange={(e) =>
                                  handleChangeEditData("mrp", e.target.value)
                                }
                              />
                            ) : (
                              item.mrp || "0"
                            )}
                          </td>
                          <td style={tdStyle}>
                            {editMode === item.id ? (
                              <input
                                type="text"
                                value={editedData.totalqty}
                                onChange={(e) =>
                                  handleChangeEditData(
                                    "totalqty",
                                    e.target.value
                                  )
                                }
                              />
                            ) : (
                              item.totalqty || "0"
                            )}
                          </td>
                          <td style={tdStyle}>
                            {editMode === item.id ? (
                              <input
                                type="date"
                                value={editedData.expirydate ? editedData.expirydate.slice(0, 10) : ''}
                                onChange={(e) =>
                                  handleChangeEditData("expirydate", e.target.value)
                                }
                              />
                            ) : item.expirydate ? (
                              moment(item.expirydate).format("YYYY-MM-DD")
                            ) : (
                              "0"
                            )}
                          </td>


                          <td style={tdStyle}>
                            {isRowEdited(item.id) ? (
                              <span style={{ color: "orange" }}>Edited</span>
                            ) : null}
                          </td>
                          <td style={tdStyle}>
                            {editMode === item.id ? (
                              <>
                                <button
                                  onClick={() =>
                                    handleSaveEdit(item.id, editedData)
                                  }
                                  style={{ marginRight: "5px" }}
                                >
                                  Save
                                </button>
                                <button onClick={handleCancelEdit}>
                                  Cancel
                                </button>
                              </>
                            ) : (
                              <FontAwesomeIcon
                                icon={faEdit}
                                onClick={() => handleEdit(item.id)}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "10px",
                                  color: "blue",
                                }}
                              />
                            )}
                          </td>
                          <td style={tdStyle}>
                            <FontAwesomeIcon
                              icon={faTrash}
                              onClick={() => handleDelete(item.id)}
                              style={{
                                cursor: "pointer",
                                marginRight: "10px",
                                color: "red",
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="pagination">
          <button onClick={handlePrevious} disabled={currentPage === 1}>
            Previous
          </button>
          <span>
            {" "}
            {currentPage} of {Math.ceil(filteredData.length / itemsPerPage)}
          </span>
          <button
            onClick={handleNext}
            disabled={
              currentPage === Math.ceil(filteredData.length / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockDetailsPage;